const Data = [
  {
    "tree_node_id": "bcbbee51-1e30-4953-96be-cb2d975d1e16",
    "type": "section",
    "ltree_path": "9e57b1c5_a0f2_4254_9dce_99a83f68b2bd.a4805738_25c8_4c5e_81aa_147924014e26.f8d5e79d_0490_4cb3_932d_4d0edf0a735c",
    "sibling_order": "1",
    "version_id_ref": "ccdbbb55-1652-49fa-938f-4886b2b9442d",
    "part_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
    "procedure_rev_ref": "a4805738-25c8-4c5e-81aa-147924014e26",
    "section_id_ref": "f8d5e79d-0490-4cb3-932d-4d0edf0a735c",
    "step_id_ref": null,
    "substep_id_ref": null,
    "is_deleted": false,
    "created_at": null,
    "updated_at": "2026-02-06T12:50:13.107Z",
    "detail": {
      "created_at": "2026-02-04T11:59:52.555",
      "updated_at": "2026-02-04T14:00:27.277",
      "part_details": {
        "url": "",
        "units": [],
        "part_id": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
        "created_at": "2026-02-06T12:46:15.981574",
        "is_deleted": false,
        "table_note": "",
        "updated_at": null,
        "description": "",
        "part_number": "TASKDEVTEST-14",
        "textbox_note": "",
        "type_details": {
          "name": "SUBASSEMBLY",
          "orders": "10",
          "is_none": false,
          "type_id": "088f8ceb-c778-42aa-9622-68d3ebc9f3c2",
          "is_module": false,
          "is_record": false,
          "created_at": "2025-08-04T07:38:03.266769",
          "is_deleted": false,
          "updated_at": null,
          "is_flowchart": false,
          "is_procedure": true,
          "version_id_ref": "8023a262-363a-4d07-b652-4c36aed498e3",
          "is_allow_record": false,
          "short_description": "A set of parts built standalone.",
          "is_blank_template_permitted": false
        },
        "version_id_ref": "cbc596e3-509b-42a0-9859-f615c768ebc0",
        "unit_type_details": null
      },
      "section_name": "Section Namewqew",
      "version_id_ref": "ccdbbb55-1652-49fa-938f-4886b2b9442d",
      "short_description": "Section Name",
      "procedure_tree_ref": "bcbbee51-1e30-4953-96be-cb2d975d1e16",
      "part_required_id_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
      "section_tree_node_id": "f8d5e79d-0490-4cb3-932d-4d0edf0a735c",
      "is_hide_heading_and_desc": null
    },
    "steps": [
      {
        "tree_node_id": "4ba2bc8a-e4e3-4d21-b52a-decc2eb0e5d4",
        "type": "step",
        "ltree_path": "9e57b1c5_a0f2_4254_9dce_99a83f68b2bd.a4805738_25c8_4c5e_81aa_147924014e26.f8d5e79d_0490_4cb3_932d_4d0edf0a735c.67b657e4_5947_4adf_96f9_97984e3b76ad",
        "sibling_order": "1",
        "version_id_ref": "2b75e86a-19fa-4989-9860-ef802e112953",
        "part_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
        "procedure_rev_ref": "a4805738-25c8-4c5e-81aa-147924014e26",
        "section_id_ref": "f8d5e79d-0490-4cb3-932d-4d0edf0a735c",
        "step_id_ref": "67b657e4-5947-4adf-96f9-97984e3b76ad",
        "substep_id_ref": null,
        "is_deleted": false,
        "created_at": "2026-02-10T11:59:28.327Z",
        "updated_at": "2026-02-10T11:59:28.333Z",
        "detail": {
          "step_data": {
            "step_details": [],
            "parts_required": [],
            "bom_table_title_info": {
              "field_name": "Step \u003E BOM Table for Step Title",
              "is_deleted": false,
              "category_id": "ffbee55e-ed00-46fb-a6e0-50895377949e",
              "description": "system generated",
              "category_name": "Items Required"
            },
            "part_number_column_title_ref_info": {
              "field_name": "Step \u003E Item Code Column Title",
              "is_deleted": false,
              "category_id": "69cb4a92-30e5-4a54-9066-cb7a6fef7b93",
              "description": "system generated",
              "category_name": "Item Code"
            }
          },
          "created_at": "2026-02-10T11:59:28.331281",
          "updated_at": null,
          "version_id_ref": "2b75e86a-19fa-4989-9860-ef802e112953",
          "is_hide_bom_table": false,
          "is_updated_master": false,
          "short_description": "Short Description\n",
          "step_tree_node_id": "67b657e4-5947-4adf-96f9-97984e3b76ad",
          "procedure_tree_ref": "4ba2bc8a-e4e3-4d21-b52a-decc2eb0e5d4",
          "past_step_data_json": {
            "bom_rows": [],
            "step_details": [],
            "bom_table_title_info": {
              "category_id": "ffbee55e-ed00-46fb-a6e0-50895377949e",
              "category_name": "Items Required"
            },
            "part_number_column_title_ref_info": {
              "category_id": "69cb4a92-30e5-4a54-9066-cb7a6fef7b93",
              "category_name": "Item Code"
            }
          },
          "is_hide_step_details": false,
          "is_hide_step_heading": false,
          "bom_table_for_step_title_ref": "ffbee55e-ed00-46fb-a6e0-50895377949e",
          "part_number_column_title_ref": "69cb4a92-30e5-4a54-9066-cb7a6fef7b93"
        },
        "substeps": [],
        "children": [
          {
            "tree_node_id": "83f1aec6-5981-404d-8978-71dbc1175e9a",
            "type": "attachment",
            "ltree_path": "9e57b1c5_a0f2_4254_9dce_99a83f68b2bd.a4805738_25c8_4c5e_81aa_147924014e26.f8d5e79d_0490_4cb3_932d_4d0edf0a735c.67b657e4_5947_4adf_96f9_97984e3b76ad.c0d6e5c3_ac95_4555_9c40_abd3462864f8",
            "sibling_order": "1",
            "version_id_ref": "3b4ee346-70e1-4070-9a79-22320ad88677",
            "part_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
            "procedure_rev_ref": "a4805738-25c8-4c5e-81aa-147924014e26",
            "section_id_ref": "f8d5e79d-0490-4cb3-932d-4d0edf0a735c",
            "step_id_ref": "67b657e4-5947-4adf-96f9-97984e3b76ad",
            "substep_id_ref": null,
            "is_deleted": false,
            "created_at": "2026-02-10T12:03:43.051Z",
            "updated_at": "2026-02-10T12:03:43.064Z",
            "detail": {
              "created_at": "2026-02-10T12:03:43.055122",
              "updated_at": "2026-02-10T12:03:43.055122",
              "attachments": [
                {
                  "attachment": "https://dcms-project-bucket.s3.eu-north-1.amazonaws.com/developer/attachment/attachment-1770725017737.png",
                  "created_at": "2026-02-10T12:03:43.058887",
                  "updated_at": "2026-02-10T12:03:43.058887",
                  "attachment_id": "37d50321-5fe0-4186-8d81-6cf9dece761a",
                  "attachment_tree_node_ref": "c0d6e5c3-ac95-4555-9c40-abd3462864f8"
                },
                {
                  "attachment": "https://dcms-project-bucket.s3.eu-north-1.amazonaws.com/developer/attachment/attachment-1770725020936.png",
                  "created_at": "2026-02-10T12:03:43.059671",
                  "updated_at": "2026-02-10T12:03:43.059671",
                  "attachment_id": "9cf9d6fb-a8c9-407e-a91c-4560688d0162",
                  "attachment_tree_node_ref": "c0d6e5c3-ac95-4555-9c40-abd3462864f8"
                }
              ],
              "version_id_ref": "3b4ee346-70e1-4070-9a79-22320ad88677",
              "short_description": "Short Description\n",
              "procedure_tree_ref": "83f1aec6-5981-404d-8978-71dbc1175e9a",
              "attachment_tree_node_id": "c0d6e5c3-ac95-4555-9c40-abd3462864f8"
            }
          },
          {
            "tree_node_id": "4db0b52b-914c-4bc1-a7d8-ae68c3ff4c29",
            "type": "attachment",
            "ltree_path": "9e57b1c5_a0f2_4254_9dce_99a83f68b2bd.a4805738_25c8_4c5e_81aa_147924014e26.f8d5e79d_0490_4cb3_932d_4d0edf0a735c.67b657e4_5947_4adf_96f9_97984e3b76ad.025b048e_2530_4679_96fb_4339ed32ac52",
            "sibling_order": "2",
            "version_id_ref": "c64e8818-e9b2-47dc-8d27-a96715a87cd8",
            "part_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
            "procedure_rev_ref": "a4805738-25c8-4c5e-81aa-147924014e26",
            "section_id_ref": "f8d5e79d-0490-4cb3-932d-4d0edf0a735c",
            "step_id_ref": "67b657e4-5947-4adf-96f9-97984e3b76ad",
            "substep_id_ref": null,
            "is_deleted": false,
            "created_at": "2026-02-10T13:08:08.383Z",
            "updated_at": "2026-02-10T13:08:08.411Z",
            "detail": {
              "created_at": "2026-02-10T13:08:08.38989",
              "updated_at": "2026-02-10T13:20:03.714574",
              "attachments": [
                {
                  "attachment": "https://dcms-project-bucket.s3.eu-north-1.amazonaws.com/developer/attachment/attachment-1770728877832.png"
                },
                {
                  "attachment": "https://dcms-project-bucket.s3.eu-north-1.amazonaws.com/developer/attachment/attachment-1770728881063.png"
                },
                {
                  "attachment": "https://dcms-project-bucket.s3.eu-north-1.amazonaws.com/developer/attachment/attachment-1770729595123.pdf"
                }
              ],
              "version_id_ref": "c64e8818-e9b2-47dc-8d27-a96715a87cd8",
              "short_description": "New Attachment 3 UPDATED",
              "procedure_tree_ref": "4db0b52b-914c-4bc1-a7d8-ae68c3ff4c29",
              "attachment_tree_node_id": "025b048e-2530-4679-96fb-4339ed32ac52"
            }
          },
          {
            "tree_node_id": "e984b18c-303e-4272-8f6b-d55741178bb7",
            "type": "attachment",
            "ltree_path": "9e57b1c5_a0f2_4254_9dce_99a83f68b2bd.a4805738_25c8_4c5e_81aa_147924014e26.f8d5e79d_0490_4cb3_932d_4d0edf0a735c.67b657e4_5947_4adf_96f9_97984e3b76ad.99939797_132a_421c_b357_4e3eddd89a8a",
            "sibling_order": "3",
            "version_id_ref": "aed8830c-0eb8-4d50-9cfa-5f6b712afba0",
            "part_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
            "procedure_rev_ref": "a4805738-25c8-4c5e-81aa-147924014e26",
            "section_id_ref": "f8d5e79d-0490-4cb3-932d-4d0edf0a735c",
            "step_id_ref": "67b657e4-5947-4adf-96f9-97984e3b76ad",
            "substep_id_ref": null,
            "is_deleted": false,
            "created_at": "2026-02-10T12:31:18.253Z",
            "updated_at": "2026-02-10T12:31:18.272Z",
            "detail": {
              "created_at": "2026-02-10T12:31:18.263404",
              "updated_at": "2026-02-10T12:31:18.263404",
              "attachments": [
                {
                  "attachment": "https://dcms-project-bucket.s3.eu-north-1.amazonaws.com/developer/attachment/attachment-1770726668977.csv",
                  "created_at": "2026-02-10T12:31:18.266399",
                  "updated_at": "2026-02-10T12:31:18.266399",
                  "attachment_id": "94d1f6ce-ed30-48d6-8d70-8550f88a7e00",
                  "attachment_tree_node_ref": "99939797-132a-421c-b357-4e3eddd89a8a"
                },
                {
                  "attachment": "https://dcms-project-bucket.s3.eu-north-1.amazonaws.com/developer/attachment/attachment-1770726672563.csv",
                  "created_at": "2026-02-10T12:31:18.26643",
                  "updated_at": "2026-02-10T12:31:18.26643",
                  "attachment_id": "b9c21681-c999-42a8-be00-ca6fc5227c52",
                  "attachment_tree_node_ref": "99939797-132a-421c-b357-4e3eddd89a8a"
                }
              ],
              "version_id_ref": "aed8830c-0eb8-4d50-9cfa-5f6b712afba0",
              "short_description": "NEW ATTACHMENT",
              "procedure_tree_ref": "e984b18c-303e-4272-8f6b-d55741178bb7",
              "attachment_tree_node_id": "99939797-132a-421c-b357-4e3eddd89a8a"
            }
          }
        ]
      }
    ]
  },
  {
    "tree_node_id": "d129dd98-01c4-42fb-8daf-eda45217834e",
    "type": "section",
    "ltree_path": "9e57b1c5_a0f2_4254_9dce_99a83f68b2bd.a4805738_25c8_4c5e_81aa_147924014e26.acad61d4_022f_4011_88ff_70c2be143432",
    "sibling_order": "2",
    "version_id_ref": "f1d8b1e8-0d3b-4577-bedb-7473adc144a3",
    "part_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
    "procedure_rev_ref": "a4805738-25c8-4c5e-81aa-147924014e26",
    "section_id_ref": "acad61d4-022f-4011-88ff-70c2be143432",
    "step_id_ref": null,
    "substep_id_ref": null,
    "is_deleted": false,
    "created_at": null,
    "updated_at": "2026-02-06T12:50:13.168Z",
    "detail": {
      "created_at": "2026-02-06T12:17:13.302",
      "updated_at": null,
      "part_details": {
        "url": "",
        "units": [],
        "part_id": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
        "created_at": "2026-02-06T12:46:15.981574",
        "is_deleted": false,
        "table_note": "",
        "updated_at": null,
        "description": "",
        "part_number": "TASKDEVTEST-14",
        "textbox_note": "",
        "type_details": {
          "name": "SUBASSEMBLY",
          "orders": "10",
          "is_none": false,
          "type_id": "088f8ceb-c778-42aa-9622-68d3ebc9f3c2",
          "is_module": false,
          "is_record": false,
          "created_at": "2025-08-04T07:38:03.266769",
          "is_deleted": false,
          "updated_at": null,
          "is_flowchart": false,
          "is_procedure": true,
          "version_id_ref": "8023a262-363a-4d07-b652-4c36aed498e3",
          "is_allow_record": false,
          "short_description": "A set of parts built standalone.",
          "is_blank_template_permitted": false
        },
        "version_id_ref": "cbc596e3-509b-42a0-9859-f615c768ebc0",
        "unit_type_details": null
      },
      "section_name": "Section Name",
      "version_id_ref": "f1d8b1e8-0d3b-4577-bedb-7473adc144a3",
      "short_description": "Short Description\n",
      "procedure_tree_ref": "d129dd98-01c4-42fb-8daf-eda45217834e",
      "part_required_id_ref": "9e57b1c5-a0f2-4254-9dce-99a83f68b2bd",
      "section_tree_node_id": "acad61d4-022f-4011-88ff-70c2be143432",
      "is_hide_heading_and_desc": false
    },
    "steps": []
  }
]
export default Data